import React, { Component } from 'react'
import { Link } from "react-router-dom";
import DropdownSelect from "../../../components/dropdown/Dropdown";
import DropdownAction from "../../../components/dropdown/DropdownAction";
import SwalServices from '../../../services/swalServices/SwalServices';
import MembershipCorporateServices from '../../../services/axiosServices/apiServices/MembershipCorporateServices'
import Table from '../../../components/table/Table';
import ActionContainer from '../../../components/UIComponent/ActionTableComponent/actionContainer';
import { Navigate } from 'react-router-dom';
import { CommonSuccessMessages } from "../../../utils/Messages";
import { encryptAES } from '../../../utils/Encryption';
//import CommonServices from "../../../services/axiosServices/apiServices/CommonServices";


export default class ViewCorporateMembers extends Component {
  constructor(props) {
    super(props)
    this.membershipCorporateServices = new MembershipCorporateServices();
    //this.CommonServices = new CommonServices();
    this.swalServices = new SwalServices();
    this.state = {
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
        searchByUENNumber: "",
        statusId: 0
      },
      corporateMemberList: [],
      totalResultes: 0,
      statuses: [],
      actionDropdown: ['Activate', 'Deactivate', 'Update', 'Delete']
    }
  }


  setFilterParameters = (id) => {
    let detail = this.state.pagination;
    detail.pageNo = 1;
    detail.statusId = id;
    this.setState({ pagination: { ...detail } }, () => {
      this.getMembershipCorporateList();
    });
  }

  searchByName = (value, identity) => {
    let detail = this.state.pagination;
    if (identity === "searchByCompanyName") {
      detail.pageNo = 1;
      detail.pageSize = 10;
      detail.searchText = value;
      this.setState({ pagination: { ...detail } });
    }
    else if (identity === "searchByUENNumber") {
      detail.pageNo = 1;
      detail.pageSize = 10;
      detail.searchByUENNumber = value;
      this.setState({ pagination: { ...detail } });
    }
    this.getMembershipCorporateList();
  }

  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination });
    this.getMembershipCorporateList();
  }

  onClose = () => {
    this.setState({ setDropdownOpen: false })
  }

  actionClick = (index, value, option) => {
    if (value && value > 0 && option === 'Deactivate') {
      this.deActivateCorporateMemnber(value);
    }
    if (value && value > 0 && option === 'Activate') {
      this.activeInActiveCorporateMember(value);
    }
    if (value && value > 0 && option === 'Update') {
      this.updateCorporateMemberUpdate(value);
    }
    if (value && value > 0 && option === 'Delete') {
      this.deleteCorporateMember(value);
    }
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ setDropdownOpen: false })
    }
  }
  deActivateCorporateMemnber = (value) => {
    let request = {
      id: value,
      statusId: 7
    }
    this.swalServices.Confirm(CommonSuccessMessages.Are_You_Sure, CommonSuccessMessages.Message_text.replace("{0}", "Member will be deactivated."),
      CommonSuccessMessages.Yes_Text, CommonSuccessMessages.No_Text).then((response) => {
        if (response) {
          if (this.state.isLoading) return;
          this.setState({ isLoading: true });
          this.membershipCorporateServices.activeInActiveCorporateMember(request).then((response) => {
            this.setState({ isLoading: false });
            if (response.statusCode === 200) {
              this.swalServices.Success("Corporate member deactivated Successfully.");
              this.getMembershipCorporateList();
            } else {
              this.swalServices.Error(response.message);
            }
          }).catch(() => {
            this.setState({ isLoading: false });
            this.swalServices.Error("Something went wrong. Please try again.");
          })
        }
      });
  }

  activeInActiveCorporateMember = (value) => {
    let request = {
      id: value,
      statusId: 8
    }
    this.swalServices.Confirm(CommonSuccessMessages.Are_You_Sure, CommonSuccessMessages.Message_text.replace("{0}", "Member will be activated."),
      CommonSuccessMessages.Yes_Text, CommonSuccessMessages.No_Text).then((response) => {
        if (response) {
          if (this.state.isLoading) return;
          this.setState({ isLoading: true });
          this.membershipCorporateServices.activeInActiveCorporateMember(request).then((response) => {
            this.setState({ isLoading: false });
            if (response.statusCode === 200) {
              this.swalServices.Success("Corporate member activated Successfully.");
              this.getMembershipCorporateList();
            } else {
              this.swalServices.Error(response.message);
            }
          }).catch(() => {
            this.setState({ isLoading: false });
            this.swalServices.Error("Something went wrong. Please try again.");
          });
        }
      });
  }

  updateCorporateMemberUpdate = (value) => {
    if (value && value > 0) {
      this.setState({ route: '/CreateCorporateMembers/CorporateMemberId?=' + encryptAES(value) });
    }
  }

  deleteCorporateMember = (value) => {
    let request = {
      id: value,
      deletedBy: 1,
      appId: 115
    }
    this.swalServices.Confirm(CommonSuccessMessages.Confirm_Question.replace("{0}", "Member"), CommonSuccessMessages.Confirm_Delete.replace("{0}", "Member"),
      CommonSuccessMessages.Yes_Text, CommonSuccessMessages.No_Text).then((response) => {
        if (response) {
          if (this.state.isLoading) return;
          this.setState({ isLoading: true });
          this.membershipCorporateServices.deleteCorporateMember(request).then((response) => {
            this.setState({ isLoading: false });
            if (response.statusCode === 200) {
              this.swalServices.Success("Deleted");
              this.getMembershipCorporateList();
            } else {
              this.swalServices.Error(response.message);
            }
          }).catch(() => {
            this.setState({ isLoading: false });
            this.swalServices.Error("Something went wrong. Please try again.");
          });
        }
      });
  }

  actions = (element, index, value) => {
    return element !== "corporateMemberId" ? null : (
      <td>
        <ActionContainer>
          <DropdownAction
            key={index}
            index={index}
            value={value}
            options={this.state.actionDropdown}
            align="right"
            onOptionClick={this.actionClick.bind(this)}
          />
        </ActionContainer>
      </td>
    );
  };

  getAllCorporateStatus = () => {
    this.membershipCorporateServices.getAllCorporateStatus().then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        this.setState({ statuses: response.responseItem.responseContent }, () => this.getMembershipCorporateList());
      }
      else {
        this.getMembershipCorporateList();
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    }).catch((error) => {
      this.setState({ isLoading: false });
    });
  }

  getMembershipCorporateList = (pagination = this.state.pagination) => {
    this.setState({ isLoading: true });

    this.membershipCorporateServices.getMembershipCorporateList(pagination).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        this.setState({ corporateMemberList: response.responseItem.responseContent.itemList, totalResultes: response.responseItem.responseContent.totalCount });
      }
      else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    }).catch(() => {
      this.setState({ isLoading: false });
    })
  }

  componentDidMount() {

    this.getAllCorporateStatus();
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  render() {
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }
    return (
      <div className="main-body-section" >
        <div className="flex">
          <div className="relative flex flex-col flex-1 "></div>
        </div>
        <main className="lg:pb-10 sm:pb-4 pb-4">
          <div className="custom-card shadow-lg 2xl:mb-3 lg:mb-3 sm:mb-5 mb-6">
            <div className="filter-info grid grid-cols-12 lg:gap-6 sm:gap-3 gap-3">
              <div className="filter-types 2xl:col-span-4 lg:col-span-4 col-span-12">
                <h2
                  className="filter-lable block font-medium theme-color min-h-30"
                  htmlFor="default"
                >
                  Search by Company Name
                </h2>
                <input
                  id="default"
                  className="form-input rounded-none w-full shadow-red py-3 text-lg"
                  type="text"
                  onChange={(e) => this.searchByName(e.target.value, 'searchByCompanyName')}
                />
              </div>
              <div className="filter-types 2xl:col-span-4 lg:col-span-4 col-span-12">
                <h2
                  className="filter-lable block font-medium theme-color min-h-30"
                  htmlFor="default"
                >
                  Search by UEN Number
                </h2>
                <input
                  id="default"
                  className="form-input rounded-none w-full shadow-red py-3 text-lg"
                  type="text"
                  onChange={(e) => this.searchByName(e.target.value, "searchByUENNumber")}
                />
              </div>

              <div className="filter-types 2xl:col-span-4 lg:col-span-4 col-span-12">
                <h2
                  className="lg:pl-6 filter-lable block font-medium theme-color min-h-30 "
                  htmlFor="default"
                >
                  Status
                </h2>
                <div className="lg:pl-6 lg:border-l-[1px] border-[#757575]">
                  <DropdownSelect
                    //drpIdentity={"MembershipType"}
                    optionArray={this.state.statuses}
                    setFilterParameters={this.setFilterParameters}
                    value={this.state.pagination.statusId}
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="py-3 text-sm text-gray-700 max-w-6xl">
            <p class="font-semibold mb-2">Membership Status</p>
            <div class="grid grid-cols-[auto_auto] gap-x-32 leading-relaxed">
              <p>
                <span class="font-semibold">NEW APPLICATION: </span>
                Upon new application submitted
              </p>
              <p>
                <span class="font-semibold">INACTIVE: </span>
                Corporate membership is Active and subscription end date is past
              </p>
              <p>
                <span class="font-semibold">ACTIVE-NEW: </span>
                When invoice is generated
              </p>
              <p>
                <span class="font-semibold">INACTIVE-NEW: </span>
                Company is Active-New and Credit term + 30 days has past
              </p>
              <p>
                <span class="font-semibold">ACTIVE: </span>
                When membership is paid
              </p>
              <p>
                <span class="font-semibold">EX-MEMBER: </span>
                Corporate membership is Inactive and subscription end date is past for more than 90 days
              </p>
            </div>
          </div>

          <div className="w-full mx-auto">
            <div className="sm:flex flex justify-between items-center sm:justify-between sm:items-center 2xl:mb-4 mb-2 lg:mb-5 ">
              <h1 className="table-title-txt theme-color font-bold pl-0">
                Total : {this.state.totalResultes}
              </h1>
              <div className="grid grid-flow-col sm:auto-cols-max sm:justify-end justify-end gap-3">
                <Link to="/CreateCorporateMembers">
                  <button className="btn btn-red text-white">
                    <span className="text-xl text-white font-semibold tracking-normal">
                      {" "}
                      Create New{" "}
                    </span>
                  </button>
                </Link>
              </div>
            </div>

            <div className="relative">
              <div>
                <div className="" onMouseLeave={() => this.onClose()} >
                  <Table columns={[{ name: 'siisAccountId', title: 'SIIS Account Id' }, { name: 'companyName', title: 'Company Name' }, { name: 'companyUEN', title: 'UEN Number' }, { name: 'isFeatured', title: 'Featured' }, { name: 'statusName', title: 'status' }, { name: 'corporateMemberId', title: 'Actions' }]}
                    rows={this.state.corporateMemberList}
                    isLoading={this.state.isLoading}
                    sortingColumns={["companyName", "membershipTypeName", "statusName"]}
                    pagination={this.state.pagination}
                    totalResultes={this.state.totalResultes}
                    totalCount={this.state.totalResultes}
                    setPagination={this.setPagination.bind(this)}
                    customScope={[
                      {
                        column: 'corporateMemberId',
                        renderTableData: this.actions.bind(this)
                      },
                    ]} />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    )
  }
}